import inherited from 'mastodon/locales/ro.json';

const messages = {
  //  No translations available.
};

export default Object.assign({}, inherited, messages);
